import { Components, Theme } from '@mui/material/styles';

export const MuiChip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    root: {
      borderRadius: 3,
    },
    outlined: {
      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--palette-action-hover) 10%, transparent)',
      },
    },
  },
};
